import { Model } from '@/models/Model';
import { DateTime } from 'luxon';
export class Schedule extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Schedule';
        this.$endpoint = '/schedules';
        this.$fillable = ['name', 'tags'];
    }
    truncate(text, amount) {
        return `${text.substr(0, amount)}...`;
    }
    formatTime(property) {
        return DateTime.fromSQL(this[property]).toFormat('HH:mm');
    }
}
